/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */

import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, message, Modal, Space, Breadcrumb, Empty } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined, CheckOutlined, CloseOutlined, EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getPendingRiders, reviewRiderApplication, batchReviewRiderApplications } from '../../redux/riderSlice';
import { style } from '../../Styles';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import RiderDetailsDrawer from './RiderDetailsDrawer';

const { TextArea } = Input;

const PendingRidersComponent = ({ isActive }) => {
	const dispatch = useDispatch();
	const { PendingRiders } = useSelector((state) => state.riders);
	const [isMakingApiCall, setMakingApiCall] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [sortBy, setSortBy] = useState('created');
	const [sortDirection, setSortDirection] = useState('DESC');

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field || 'created');
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('created');
			setSortDirection('DESC');
		}
		setCurrentPage(1);
	};
	const [reviewModal, setReviewModal] = useState({
		visible: false,
		rider: null,
		action: null,
		comments: '',
		submitting: false,
	});
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [selectedRider, setSelectedRider] = useState(null);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [batchReviewModal, setBatchReviewModal] = useState({
		visible: false,
		action: null,
		comments: '',
		submitting: false,
	});

	const columns = [
		{
			title: 'Profile Picture',
			key: 'profilePicture',
			render: (record) => {
				return record.profilePicture ? (
					<ImageComponent size={40} imageId={record?.profilePicture} />
				) : (
					<CustomAvatar name={`${record.name} ${record.surname}`} type='initials' />
				);
			},
			width: 90,
			show: true,
		},
		{
			title: 'Name',
			key: 'name',
			render: (record) => {
				return <span>{`${record.name} ${record.surname}`}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
			width: 200,
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
			width: 175,
		},
		{
			title: 'Phone',
			key: 'phone',
			render: (record) => {
				return <span>{`+(${record.phoneCountryCode}) ${record.phone}`}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Country',
			key: 'country',
			render: (record) => {
				return record.country ? <span>{`${record.country} `}</span> : <span>-</span>;
			},
			show: true,
		},
		{
			title: 'Registration Date',
			key: 'created',
			render: (record) => {
				return record.created ? (
					<span>{dayjs(record.created).format('DD/MM/YYYY HH:mm')}</span>
				) : (
					<span>-</span>
				);
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
			width: 150,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<Space>
					<Button
						type='primary'
						icon={<CheckOutlined />}
						size='small'
						onClick={() => handleReviewAction(record, 'approve')}
						style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
						Approve
					</Button>
					<Button
						type='primary'
						danger
						icon={<CloseOutlined />}
						size='small'
						onClick={() => handleReviewAction(record, 'reject')}>
						Deny
					</Button>
					<Button
						type='default'
						icon={<EyeOutlined />}
						size='small'
						onClick={() => handleViewRider(record)}
					>
						View
					</Button>
				</Space>
			),
			width: 120,
			show: true,
		},
	];

	const handleViewRider = (rider) => {
		setSelectedRider(rider);
		setDrawerOpen(true);
	};

	const handleReviewAction = (rider, action) => {
		setReviewModal({
			visible: true,
			rider,
			action,
			comments: '',
			submitting: false,
		});
	};

	const handleReviewSubmit = async () => {
		if (!reviewModal.rider || !reviewModal.action) return;

		setReviewModal(prev => ({ ...prev, submitting: true }));

		try {
			const reviewData = {
				approved: reviewModal.action === 'approve',
				comments: reviewModal.comments || null,
			};

			await dispatch(
				reviewRiderApplication({
					riderId: reviewModal.rider.id,
					reviewData,
				})
			).unwrap();

			message.success(
				`Rider ${reviewModal.action === 'approve' ? 'approved' : 'rejected'} successfully`
			);

			setReviewModal({
				visible: false,
				rider: null,
				action: null,
				comments: '',
				submitting: false,
			});

			// Refresh the pending riders list
			fetchPendingRiders();
		} catch (error) {
			message.error(`Failed to ${reviewModal.action} rider: ${error.message}`);
			setReviewModal(prev => ({ ...prev, submitting: false }));
		}
	};

	const fetchPendingRiders = () => {
		setMakingApiCall(true);
		dispatch(getPendingRiders({
			page: currentPage - 1,
			size: pageSize,
			search,
			sortBy,
			sortDirection,
		}))
			.unwrap()
			.then(() => {
				setMakingApiCall(false);
			})
			.catch(() => {
				setMakingApiCall(false);
				message.error('Failed to fetch pending riders');
			});
	};

	const handleBatchAction = (action) => {
		if (selectedRowKeys.length === 0) {
			message.warning('Please select riders to perform batch action');
			return;
		}
		setBatchReviewModal({
			visible: true,
			action,
			comments: '',
			submitting: false,
		});
	};

	const handleBatchSubmit = async () => {
		if (selectedRowKeys.length === 0 || !batchReviewModal.action) return;

		setBatchReviewModal(prev => ({ ...prev, submitting: true }));

		try {
			const reviewData = {
				approved: batchReviewModal.action === 'approve',
				comments: batchReviewModal.comments || null,
			};

			await dispatch(
				batchReviewRiderApplications({
					riderIds: selectedRowKeys,
					reviewData,
				})
			).unwrap();

			message.success(
				`${selectedRowKeys.length} rider(s) ${batchReviewModal.action === 'approve' ? 'approved' : 'rejected'} successfully`
			);

			setBatchReviewModal({
				visible: false,
				action: null,
				comments: '',
				submitting: false,
			});

			setSelectedRowKeys([]);

			// Refresh the pending riders list
			fetchPendingRiders();
		} catch (error) {
			message.error(`Failed to ${batchReviewModal.action} riders: ${error.message}`);
			setBatchReviewModal(prev => ({ ...prev, submitting: false }));
		}
	};

	const ridersArray = (PendingRiders.ridersList || []).map((rider) => ({ ...rider, key: rider.id }));

	useEffect(() => {
		if (isActive) {
			fetchPendingRiders();
		}
	}, [isActive, currentPage, pageSize, search, sortBy, sortDirection]);

	const handleCloseDrawer = () => {
		setDrawerOpen(false);
		setSelectedRider(null);
	};
	return (
		<>
			<div style={style.inlineContent}>
				<div
					style={{
						display: 'flex',
						alignContent: 'center',
						alignItems: 'center',
						float: 'left',
						marginBottom: 8,
					}}>
					<Breadcrumb
						style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
						items={[
							{
								title: 'Riders',
							},
							{
								title: 'Pending Applications',
							},
						]}
					/>
					<Button
						type='default'
						size='small'
						onClick={fetchPendingRiders}
						loading={isMakingApiCall}
						icon={<ReloadOutlined />}
					/>
				</div>

				<div
					style={{
						...style.inlineContent,
						float: 'right',
						marginBottom: 8,
					}}>
					<Input.Search
						placeholder='Search riders...'
						style={{ width: '200px' }}
						allowClear
						onSearch={(val) => {
							if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
							setCurrentPage(1);
							setSearch(val);
						}}
						onChange={(e) => {
							const val = e.target.value;
							if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
							searchTimerRef.current = setTimeout(() => {
								setCurrentPage(1);
								setSearch(val);
							}, 400);
						}}
					/>
				</div>
			</div>

			{/* Batch Action Buttons */}
			{selectedRowKeys.length > 0 && (
				<div style={{ marginBottom: 16, padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
					<Space>
						<span><strong>{selectedRowKeys.length}</strong> rider(s) selected</span>
						<Button
							type="primary"
							icon={<CheckOutlined />}
							onClick={() => handleBatchAction('approve')}
							size="small"
						>
							Approve
						</Button>
						<Button
							danger
							icon={<CloseOutlined />}
							onClick={() => handleBatchAction('reject')}
							size="small"
						>
							Deny
						</Button>
						<Button
							type="default"
							onClick={() => setSelectedRowKeys([])}
							size="small"
						>
							Clear
						</Button>
					</Space>
				</div>
			)}

			{ridersArray.length === 0 && !isMakingApiCall ? (
				<Empty
					description='No pending rider applications'
					style={{ marginTop: '50px' }}
				/>
			) : (
				<CustomTableComponentsPageable
					isMakingApiCall={isMakingApiCall}
					columns={columns.filter(col => col.show)}
					dataArray={ridersArray}
					handleDoubleClickRow={handleViewRider}
					handleSelectedRow={() => { }}
					onTableChange={handleTableChange}
					rowSelection={{
						selectedRowKeys,
						onChange: setSelectedRowKeys,
						type: 'checkbox',
					}}
					pagination={{
						current: currentPage,
						pageSize,
						total: PendingRiders.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			)}

			{/* Review Modal */}
			<Modal
				title={`${reviewModal.action === 'approve' ? 'Approve' : 'Deny'} Rider Application`}
				open={reviewModal.visible}
				onOk={handleReviewSubmit}
				onCancel={() => setReviewModal({ visible: false, rider: null, action: null, comments: '', submitting: false })}
				confirmLoading={reviewModal.submitting}
				okText={reviewModal.action === 'approve' ? 'Approve' : 'Deny'}
				okButtonProps={{
					danger: reviewModal.action === 'reject',
					type: reviewModal.action === 'approve' ? 'primary' : 'default',
				}}>
				<div style={{ marginBottom: 16 }}>
					<strong>Rider:</strong> {reviewModal.rider?.name} {reviewModal.rider?.surname}
				</div>
				<div style={{ marginBottom: 16 }}>
					<strong>Email:</strong> {reviewModal.rider?.email}
				</div>
				<div style={{ marginBottom: 16 }}>
					<label>
						<strong>Comments {reviewModal.action === 'reject' ? '(Required)' : '(Optional)'}:</strong>
					</label>
					<TextArea
						rows={4}
						value={reviewModal.comments}
						onChange={(e) => setReviewModal(prev => ({ ...prev, comments: e.target.value }))}
						placeholder={`Add comments for ${reviewModal.action === 'approve' ? 'approval' : 'rejection'}...`}
						required={reviewModal.action === 'reject'}
					/>
				</div>
			</Modal>

			{/* Batch Review Modal */}
			<Modal
				title={`Batch ${batchReviewModal.action === 'approve' ? 'Approve' : 'Deny'} Rider Applications`}
				open={batchReviewModal.visible}
				onOk={handleBatchSubmit}
				onCancel={() => setBatchReviewModal({ visible: false, action: null, comments: '', submitting: false })}
				confirmLoading={batchReviewModal.submitting}
				okText={`${batchReviewModal.action === 'approve' ? 'Approve' : 'Deny'} ${selectedRowKeys.length} Rider(s)`}
				okButtonProps={{
					danger: batchReviewModal.action === 'reject',
					type: batchReviewModal.action === 'approve' ? 'primary' : 'default',
				}}>
				<div style={{ marginBottom: 16 }}>
					<strong>Selected Riders:</strong> {selectedRowKeys.length} rider(s)
				</div>
				<div style={{ marginBottom: 16 }}>
					<label>
						<strong>Comments {batchReviewModal.action === 'reject' ? '(Required)' : '(Optional)'}:</strong>
					</label>
					<TextArea
						rows={4}
						value={batchReviewModal.comments}
						onChange={(e) => setBatchReviewModal(prev => ({ ...prev, comments: e.target.value }))}
						placeholder={`Add comments for batch ${batchReviewModal.action === 'approve' ? 'approval' : 'rejection'}...`}
						required={batchReviewModal.action === 'reject'}
					/>
				</div>
			</Modal>

			{/* View Rider Drawer */}
			{/* {drawerOpen && (
				<DrawerRider
					onClose={() => {
						setDrawerOpen(false);
						setSelectedRider(null);
					}}
					riderId={selectedRider?.id}
					isPendingView
				/>
			)} */}
			<RiderDetailsDrawer
				open={drawerOpen}
				onClose={handleCloseDrawer}
				rider={selectedRider}
				onApprove={(rider) => handleReviewAction(rider, 'approve')}
				onDeny={(rider) => handleReviewAction(rider, 'reject')}
			/>
		</>
	);
};

export default PendingRidersComponent;